// extracted by mini-css-extract-plugin
export default {"header":"Header_header__VTRqb","main-image":"Header_main-image__0a-0Y"};